import { Outlet } from 'react-router-dom';
import { Sidebar, type NavItem } from './Sidebar';
import { ToastContainer } from './Toast';

interface Props {
  brand?: string;
  brandPrefix?: string;
  footer?: React.ReactNode;
  navItems?: NavItem[];
}

/**
 * Top-level app shell — sidebar + main + toast layer.
 *
 * Place this above your `<Routes>` (or as the parent route element). Pass
 * `navItems` to wire up the sidebar links for your project.
 */
export function Layout({ brand, brandPrefix, footer, navItems }: Props) {
  return (
    <div className="flex h-screen overflow-hidden bg-white">
      <Sidebar brand={brand} brandPrefix={brandPrefix} footer={footer} navItems={navItems} />
      <main className="flex-1 overflow-auto px-16 py-8">
        <Outlet />
      </main>
      <ToastContainer />
    </div>
  );
}
